import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { useAppStateContext } from 'src/appState/AppState';
import { UniverseComponent } from 'src/domains/common/universes';
import {
    OverlayDefault,
    Content,
    PopupHeader,
    PopupDescription,
} from 'src/domains/players/webview/components/Account/BlockingNotifications/BlockingNotifications.style';
import { AcceptBtnContact } from 'src/domains/players/webview/components/Account/BlockingNotifications/BlockingNotificationsDefault.style';
import { ContactPreferencesNewState } from 'src/domains/players/webview/components/Account/preferencesTab/contactPreferencesNew/ContactPreferencesNew.state';
import { OffersSettingsNew } from 'src/domains/players/webview/components/SignUp/signupPrimary/signUpViews/createAccount/yourDetails/offersSettingsNew/OffersSettingsNew';

interface BlockingKycNotificationType {
    onConfirm: () => Promise<void>;
}

export const BlockingContactPreferencesNotification = observer(
    'BlockingContactPreferencesNotification',
    ({ onConfirm }: BlockingKycNotificationType): JSX.Element | null => {
        const {
            config: { contactPreferencesCategories },
            common,
        } = useAppStateContext();
        const id = common.session.userId;
        const [contactPreferences] = useState(() => new ContactPreferencesNewState(common));
        const state = contactPreferences.offersContactPreferencesNewStateAuto.get([]);

        const handleChangeContactPreferences = async (): Promise<void> => {
            try {
                await contactPreferences.submitContactPreferences(id, state);
                await onConfirm();
            } catch (e) {
                console.error('handleChangeContactPreferences');
            }
        };

        return (
            <OverlayDefault data-test='overlay-prompt'>
                <Content>
                    <UniverseComponent>
                        {(universeModule): React.ReactElement => <universeModule.compliancePopupLogo />}
                    </UniverseComponent>

                    <PopupHeader>
                        <I18n
                            langKey='account.contact-preferences.title'
                            defaultText='Choose how you receive marketing'
                        />
                    </PopupHeader>
                    <PopupDescription>
                        <I18n
                            langKey='account.contact-preferences.description-part-2'
                            defaultText='Receive updates on exclusive offers, free bets & free spins by product and communication method.'
                        />
                    </PopupDescription>

                    <OffersSettingsNew
                        state={state}
                        contactPreferencesCategories={contactPreferencesCategories}
                        haveHeader={false}
                        additionalContainer={true}
                    />

                    <AcceptBtnContact
                        onClick={handleChangeContactPreferences}
                        size='medium'
                    >
                        <I18n
                            langKey='account.contact-preferences.confirm-button.label'
                            defaultText='Confirm'
                        />
                    </AcceptBtnContact>
                </Content>
            </OverlayDefault>
        );
    }
);
